import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-white text-navy" data-id="element-26" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-27" data-mp="vtxoahhops0l">
        <h2 id="bonos" className="font-display text-3xl font-extrabold uppercase leading-none tracking-tight sm:text-5xl" data-id="element-28" data-mp="qu2vu9i9gudf">
          <span className="inline-block rounded-lg bg-navy px-2 py-1 text-sol" data-id="element-29" data-mp="14rzt784jh4t5">
            5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2.5 max-w-xl text-sm leading-snug text-navy/80" data-id="element-30" data-mp="1ejdzbyqzx2v9">
          Y además recibís 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-coral" data-id="element-31" data-mp="19lc8usr8q19r">
            GRATIS con tu compra.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-32" data-mp="1nkbwbx30oa4c">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className={`flex h-full flex-col overflow-hidden rounded-xl border-2 border-navy bg-cielo text-left ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-33" data-mp="1jk1oeevnz9mu" data-mpi={i}>
              <span className="border-b-2 border-navy bg-sol px-2.5 py-1 font-display text-sm font-extrabold uppercase text-navy" data-id="element-34" data-mp="2np54dqwvk2f">
                Bono {i + 1} — Gratis
              </span>
              <div className="flex flex-1 flex-col p-2.5" data-id="element-35" data-mp="cjjtzqlqabdn">
                <h3 className="font-sub text-sm font-bold leading-tight text-navy" data-id="element-36" data-mp="gklvyf7151jb">
                  {bono.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-navy/80 sm:text-sm" data-id="element-37" data-mp="lcvo81vmador">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 text-xs font-bold text-navy/80" data-id="element-38" data-mp="vajlozklxzam">
                  Valor:{' '}
                  <span className="text-coral line-through decoration-2" data-id="element-39" data-mp="108uvjaawk9su">
                    {bono.value}
                  </span>
                </p>
              </div>
            </Reveal>)}
        </ul>

        <div className="mt-3 rounded-xl border-2 border-dashed border-sol bg-navy px-3 py-2.5 leading-tight" data-id="element-40" data-mp="5mxf4ta55wyq">
          <p className="font-sub text-base font-semibold text-white" data-id="element-41" data-mp="kc3j0ujxcbcy">
            💰 Valor total de los 5 bonos:{' '}
            <span className="text-white/80 line-through decoration-coral decoration-2" data-id="element-42" data-mp="fiqvyouw8cmb">
              {BONUS_TOTAL}
            </span>
          </p>
          <p className="mt-1 font-display text-lg font-black uppercase text-sol sm:text-xl" data-id="element-43" data-mp="ocvtfr4j8mat">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}